import * as React from 'react';

export function EcommerceUpsell(
  props: React.HTMLAttributes<SVGSVGElement> & { label: string },
) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={props.label}
      style={{ marginLeft: '-2px' }}
    >
      <path
        d="M4 6V19.4386C4 19.8632 4.26813 20.2415 4.66877 20.3821L13.3375 23.4253C13.7663 23.5759 14.2337 23.5759 14.6625 23.4253L23.3312 20.3821C23.7319 20.2415 24 19.8632 24 19.4386V6L14.4851 8.37873C14.1666 8.45835 13.8334 8.45835 13.5149 8.37873L4 6Z"
        fill="url(#paint0_linear_844_23003)"
      />
      <path
        d="M13.5149 3.62127L4 6L13.5149 8.37873C13.8334 8.45835 14.1666 8.45835 14.4851 8.37873L24 6L14.4851 3.62127C14.1666 3.54165 13.8334 3.54165 13.5149 3.62127Z"
        fill="url(#paint1_linear_844_23003)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_844_23003"
          x1="7.5"
          y1="6"
          x2="7.5"
          y2="20.9414"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.29" />
          <stop offset="1" stopColor="white" stopOpacity="0.4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_844_23003"
          x1="7.6"
          y1="2.85714"
          x2="7.30675"
          y2="7.98896"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.52" />
          <stop offset="1" stopColor="white" stopOpacity="0.8" />
        </linearGradient>
      </defs>
    </svg>
  );
}
